import React, { FunctionComponent } from 'react';
import { Modal } from 'semantic-ui-react';
import { ClassProp } from 'helpers/types';
import withStyles from 'react-jss';
import { useLazyQuery } from 'react-apollo';
import { pathOr } from 'ramda';

import { formatDate } from 'helpers/date';
import Table from 'components/Table';
import { ChartPlaceholder } from 'components/Placeholder';
import { Direction, SortDefaultColumn } from 'components/Table/Table';
import { Throttle } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.types';
import { formatThrottleWithTooltip } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/components/OfferSegments/components/OfferSegment/OfferSegment.helpers';

import styles from './ThrottleHistoryModal.styles';
import GET_THROTTLE_HISTORY from './ThrottleHistory.queries';

type Styles = ClassProp<ReturnType<typeof styles>>;

type ThrottleHistoryData = {
  throttleHistoryByUuid: {
    throttleHistory: Throttle[];
  };
};
interface Props {
  classes: Styles;
  name: string;
  uuid: string;
}

const tableHeader = [
  {
    source: ['updatedAt'],
    sortable: ['updatedAt'],
    label: 'Updated At',
    transform: (date: string) => formatDate(date, 'MMM DD, YYYY'),
  },
  {
    source: ['adjustmentUpdatedBy'],
    label: 'Updated By',
  },
  {
    source: [],
    label: 'Throttle',
    transform: (throttle: Throttle) => formatThrottleWithTooltip(throttle),
  },
  {
    source: ['adjustmentReason'],
    label: 'Adjustment Reason',
  },
  {
    source: ['adjustmentReasonDetail'],
    label: 'Adjustment Detail',
  },
  {
    source: ['adjustmentTicketUrl'],
    label: 'Ticket URL',
  },
];

const sortDefaultColumn: SortDefaultColumn = {
  name: 'Updated At',
  sortable: ['updatedAt'],
  direction: Direction.DESCENDING,
};

const ThrottleHistoryModal: FunctionComponent<Props> = ({
  uuid,
  classes,
  name,
}) => {
  const [
    getThrottleHistory,
    { loading, data },
  ] = useLazyQuery<ThrottleHistoryData>(GET_THROTTLE_HISTORY, {
    fetchPolicy: 'no-cache',
  });

  const onClickHandler = () => {
    getThrottleHistory({
      variables: {
        params: {
          uuid,
        },
      },
    });
  };

  const throttleHistory = pathOr(
    [],
    ['throttleHistoryByUuid', 'throttleHistory'],
    data,
  );

  return (
    <Modal
      size={'large'}
      trigger={
        <button className={classes.button} onClick={onClickHandler}>
          Throttle History
        </button>
      }
      closeIcon
      className={classes.modal}
    >
      <Modal.Header>{name}</Modal.Header>
      <Modal.Content>
        {throttleHistory.length === 0 || loading ? (
          <ChartPlaceholder className={classes.chartPlaceholder} />
        ) : (
          <Table
            data={throttleHistory}
            sortDefaultColumn={sortDefaultColumn}
            tableHeader={tableHeader}
          ></Table>
        )}
      </Modal.Content>
    </Modal>
  );
};

export default withStyles(styles)(ThrottleHistoryModal);
